import { render, staticRenderFns } from "./PreOrderBackerStatus.vue?vue&type=template&id=bc373004"
import script from "./PreOrderBackerStatus.vue?vue&type=script&lang=js"
export * from "./PreOrderBackerStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports